const LoadingPage = () => {
  return (
    <div className="loading-container">
      <div className="loading-content">
        <img src="/logo512.png" alt="logo" className="logo" />
        <div className="spinner" />
        <p className="loading-text">LOADING</p>
      </div>
    </div>
  );
};

export default LoadingPage;
